import { render, staticRenderFns } from "./activityRanking.vue?vue&type=template&id=2be28663&scoped=true"
import script from "./activityRanking.vue?vue&type=script&lang=js"
export * from "./activityRanking.vue?vue&type=script&lang=js"
import style0 from "./activityRanking.vue?vue&type=style&index=0&id=2be28663&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be28663",
  null
  
)

export default component.exports